import { ValidatorFn } from '@angular/forms';

const GLN_LENGTH = 13;

export const glnValidator: ValidatorFn = (control) => {
  const value: string = control.value;

  if (!value) {
    return undefined;
  }

  if (isValidGs1Number(value, GLN_LENGTH)) {
    return undefined;
  }

  return { glnInvalid: {} };
};

// ported from Java
function isValidGs1Number(value: string, expectedLength: number): boolean {
  if (value.length !== expectedLength) return false;
  // calculate GS1 checksum -- see https://www.gs1.org/how-calculate-check-digit-manually
  const checkDigit = Number(value[expectedLength - 1]);
  if (isNaN(checkDigit) || checkDigit < 0 || checkDigit > 9) return false;
  let checkSum = 0;
  for (let i = 0; i < expectedLength - 1; i++) {
    const digit = Number(value[i]);
    if (isNaN(digit) || digit < 0 || digit > 9) return false;
    checkSum += digit * (i % 2 === 0 ? 1 : 3);
  }
  checkSum = checkSum % 10;
  if (checkSum !== 0) checkSum = 10 - checkSum;
  return checkDigit === checkSum;
}
